import { createSelector } from '@reduxjs/toolkit';

import { ProductionComponentInstance } from '@paragon/contract-library';

import { getProductionComponentInstancesForActiveProductionGroupBatchesAndBundlesTab } from './getProductionComponentInstancesForActiveProductionGroupBatchesAndBundlesTab';

export const getProductionComponentInstancesForActiveProductionGroupBatchesAndBundlesTabNotBundledByAnalysisSetGuid =
  createSelector(
    getProductionComponentInstancesForActiveProductionGroupBatchesAndBundlesTab,

    (productionComponentInstancesForActiveProductionGroup) =>
      Object.values(productionComponentInstancesForActiveProductionGroup)
        .filter((productionComponentInstance) => productionComponentInstance.bundleGuid === null)
        .reduce(
          (productionComponentInstancesByAnalysisSetGuid, productionComponentInstance) => {
            const { analysisSetGuid } = productionComponentInstance;
            productionComponentInstancesByAnalysisSetGuid[analysisSetGuid] = (
              productionComponentInstancesByAnalysisSetGuid[analysisSetGuid] ?? []
            ).concat([productionComponentInstance]);
            return productionComponentInstancesByAnalysisSetGuid;
          },
          {} as { [analysisSetGuid: string]: readonly ProductionComponentInstance[] },
        ),
  );
